import { render, staticRenderFns } from "./DormSearch.vue?vue&type=template&id=45035756&scoped=true&"
import script from "./DormSearch.vue?vue&type=script&lang=js&"
export * from "./DormSearch.vue?vue&type=script&lang=js&"
import style0 from "./DormSearch.vue?vue&type=style&index=0&id=45035756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45035756",
  null
  
)

export default component.exports